var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-content',{attrs:{"code":"404","desc":"界面在开发中......","src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }